<style scoped>
  .search-indicator{
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
  }

  .invite-members{
    background: #fff;
    padding: 10px;
    position: relative;
  }

  .invite-members > .action-button{
    width: 100%;
  }

  .invite-members > .input-field{
    text-align: center
  }

  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .action-methods{
    display: flex;
  }

  .resources-list-page-template{
    margin-bottom: 30px;
  }
</style>

<template>
    <div class="resources-list-page-template">
        <div class="action-methods" v-if="false">
          <Card shadow :padding="10" :style="{borderRadius: '0', width: '100%'}">
            <Input @on-change="debounceInput(searchValue)" v-model="searchValue"
              icon="ios-search" placeholder="Search"></Input>
            <p class="search-indicator" v-if="loadingSearch">Searching ...</p>
          </Card>
          <div class="invite-members">
            <div v-if="showInvite" class="input-field">
              <Input v-model="inviteMember" placeholder="Mobile / Email"
                icon="close-circled" @on-click="showInvite = false"
                @on-enter="dataValidation" style="margin-bottom: 5px;"></Input>
              <small>The mobile should be in the following format (+639123456789)</small>
              <Spin fix v-if="loadingInvitation">
                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                <div>Sending</div>
              </Spin>
            </div>
            <Button v-if="!showInvite && resource.subscribed" type="default" icon="plus" class="action-button" v-on:click="showInvite = true">Invite member</Button>
          </div>
        </div>
        <span v-if="resource.type == 'event' && subscribers.subscribers && subscribers.subscribers.length <= 0"
         style="display: flex;justify-content: center;marginTop:100px"> No attendees yet </span>
        <Row type="flex" justify="center" v-if="resource.type !== 'admin'">
          <Col :span="24" v-for="(item, k) in subscribers.subscribers" :key="k">
            <UserListItemComponent :item="item" :hasOptions="isUserAdmin(careplanInfo)"
              :userPermission="item.careplan_permission"
              @emitPermission="setPermission($event, item)"
              :showArrow="!isUserAdmin(careplanInfo)"
              :careplan="careplanInfo"
              v-if="(item.id != profileInfo.id && item.id != careplanInfo.creator.id) || resource.type == 'event'">
            </UserListItemComponent>
          </Col>
        </Row>
        <Row type="flex" justify="center" v-if="resource.type === 'admin'">
          <Col :span="24" v-for="(item, k) in subscribers.subscribers" :key="k">
            <UserListItemComponent :item="item"></UserListItemComponent>
          </Col>
        </Row>
        <ContentLoading v-show="isLoading" :height="60" style="height:60px;background-color:#fff; margin:0px 0px -4px 0px; padding-top: 10px 0px 10px 0px" v-for="n in 7" :key="n">
          <circle cx="30" cy="30" r="20" />
          <rect x="60" y="13" rx="4" ry="4" width="60%" height="18" />
          <rect x="60" y="33" rx="4" ry="4" width="20%" height="12" />
        </ContentLoading>

        <ModalHolder :title="''" m-top="90" :mHeight="'10vh'" :is-show="showRemoveConfirmation">
          <template slot="mheader">
            <h3>Confirm</h3>
          </template>
          <template slot="mcontent">
            <p>Set <b>{{userToPromote}}</b> as <b>{{permission}}</b>?</p>
          </template>
          <template slot="mfooter">
              <Button type="text" @click="showRemoveConfirmation = false">Cancel</Button>
              <Button type="default" v-on:click="setUserPermission(setPermissionType)"
                :loading="permissionLoader">Confirm</Button>
              <!-- <Button type="default" v-on:click="cancelInvitaion(invite)" :loading="cancelInvitationLoader">Confirm</Button> -->
          </template>
        </ModalHolder>

    </div>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";
import UserListItemComponent from '@/components/UserListItemComponent'
import WindowScrollEvent from 'vue-scroll-event/mixins/WindowOnScroll'
import ContentLoading from 'vue-content-loading';
import Utils from '@/utils'

export default {
  name: 'ResourcesFollowersListComponent',
  mixins: [WindowScrollEvent],
  data () {
    return {
      searchValue: null,
      inviteMember: null,
      showInvite: false,
      form: Cons[0].INVITE,
      showRemoveConfirmation: false,
      permissions: [{
          value: '503',
          label: 'Admin'
        }, {
          value: '99',
          label: 'Moderator'
        }, {
          value: '49',
          label: 'Editor'
        }, {
          value: '1',
          label: 'Member'
        }, {
          value: '16',
          label: 'Author'
        }, {
          value: '0',
          label: 'Admin'
        }, {
          value: '511',
          label: 'Admin'
        }
      ],
      permission: null,
      userToPromote: null,
      permissionData: {
        careplan_id: null,
        user_id: null,
        permission: null,
      },
      setPermissionType: null,
    }
  },
  props: {
    resource: {
      required: true,
      type: Object
    }
  },
  computed: {
    isLoading: {
      get() {
        if(this.resource.type == 'event'){
          return this.$store.state.resource.singleResource.isLoadingAttendees;
        }else{
          return this.$store.state.resource.singleResource.isLoadingSubscribers;
        }
      }
    },
    subscribers: {
      get () {
        if(this.resource.type == 'event'){
          return this.attendees
        }else{
          return this.$store.state.resource.singleResource.subscribers
        }
      }
    },
    attendees: {
      get () {
        return this.$store.state.resource.singleResource.attendees
      }
    },
    loadingSearch: {
      get () {
        return this.$store.state.resource.singleResource.searchLoader
      }
    },
    careplanInfo: {
      get () {
        return this.$store.state.resource.singleResource.data
      }
    },
    loadingInvitation: {
      get () {
        return this.$store.state.resource.singleResource.sendInvitationLoader
      }
    },
    permissionLoader: {
      get () {
        return this.$store.state.resource.singleResource.permissionLoader
      }
    },
    profileInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
  },
  methods: {
    askRemoveConfirmation() {
      this.$Message({
        closable: true,
        title: { content:'Confirm' },
        icon: 'help',
        message: { content: 'Set ' + this.userToPromote + ' as ' + this.permission + '.' },
        buttons: [
          { label: 'Confirm', type: 'primary', hideAfter:true, action: ()=> this.setUserPermission(this.setPermissionType) },
          { label: 'Cancel', type: 'primary', hideAfter:true, action: ()=> {} }
        ]
      });
    },
    onWindowScrolledBottom () {
      if (
        this.subscribers.next_link &&
        !this.$store.state.resource.singleResource.isLoadingSubscribers
      ) {
        this.$store.dispatch('resource/loadMoreFollowers', {
          url: this.subscribers.next_link
        })
      }
    },
    dataValidation () {
      this.form.careplan_id = this.careplanInfo.id
      if (Utils.validateEmail(this.inviteMember)) {
        this.form.email = this.inviteMember
        this.sendInvitation()
      } else if (Utils.validateMobile(this.inviteMember)) {
        this.form.mobile = this.inviteMember
        this.sendInvitation()
      } else {
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'ios-close' },
          icon: 'checkmark',
          message: { content: 'The format of Mobile/Email is not valid.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });
      }
    },
    sendInvitation () {
      this.$store.dispatch('resource/sendInvitation', this.form).then(res => {
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'Sent' },
          icon: 'checkmark',
          message: { content: 'Invitation set.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });
        this.showInvite = false
        this.clearData()
      })
    },
    clearData () {
      this.inviteMember = null
      this.form.email = null
      this.form.mobile = null
    },
    setPermission(data, user) {

      if (user.careplan_permission){
        this.permissionData.careplan_id = this.careplanInfo.id
        this.permissionData.user_id = user.id
        this.permissionData.permission = parseInt(data.value)
        this.permissionData['permission_id'] = user.careplan_permission.id
      } else {
        this.permissionData.careplan_id = this.careplanInfo.id
        this.permissionData.user_id = user.id
        this.permissionData.permission = parseInt(data.value)
      }

      this.permission = this.getPermissionLabel(data.value)
      this.userToPromote = user.display_name
      this.setPermissionType = data.type
      // this.showRemoveConfirmation = true
      this.askRemoveConfirmation();
    },
    setUserPermission(type){
      if(type == 'update'){
        this.$store.dispatch('resource/updateUserPermission', this.permissionData).then(res => {
          this.showRemoveConfirmation = false
        })
      }else{
        this.$store.dispatch('resource/addUserPermission', this.permissionData).then(res => {
          this.showRemoveConfirmation = false
        });
      }
    },
    getPermissionLabel(permissionCode) {
      if(permissionCode){
        for(let i = 0; i < this.permissions.length; i++){
          if(permissionCode == this.permissions[i].value){
            return (this.permissions[i].label)
          }
        }
      }else{
        return 'Member'
      }
    },
    isUserAdmin(data) {
      if (data.permission) {
        if ("permission" in data.permission) {
          if (
            data.permission.permission == 511 ||
            data.permission.permission == 503 ||
            data.permission.permission == 0
          )
            return true;
        }
      }
    },
    debounceInput: _.debounce(function (search_data) {
      this.$store.dispatch('resource/searchFollowers', { id: this.resource.id, search: search_data })
    }, 500)
  },
  components: {
    UserListItemComponent,
    ModalHolder,
    ContentLoading
  }
}
</script>
